import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import { FaCheck, FaExclamation, FaRegFilePdf } from 'react-icons/fa';
import Loader from 'react-loaders'

const CustomModalRetiro = (props) => {
    const FileUploader = () => {
        return (
            <div className='retiro-modal-button-area-firma'>
                <input type="file" id='uploadAssetsInput' onChange={(e) => { props.setUpdFile(e.target.files[0]) }} style={{ display: 'none' }} />
                <Button
                    onClick={() => { document.getElementById('uploadAssetsInput').click() }}
                    style={{ outline: 'none' }}
                    color="link"
                    outline>
                    Firma
                    <Badge
                        color="danger"
                        pill
                    >
                        <FaExclamation />
                    </Badge>
                </Button>
            </div>
        )
    }
    return (
      <Modal
        body={"padding-right: 0 !important"}
        isOpen={props.modal}
        toggle={props.toggle}
        size={props.size ?? "lg"}
      >
        <ModalHeader toggle={props.toggle}>{props.title}</ModalHeader>
        <ModalBody>{props.children}</ModalBody>
        {!props.nonFooter ? (
          <ModalFooter>
            <div className={"custom-modal-footer"}>
              <Button
                style={{ outline: "none" }}
                color="link"
                onClick={() => {
                  props.onDownload();
                }}
                outline
              >
                Visualizar documento
                <Badge color="succcess" pill>
                  <FaRegFilePdf size={20} />
                </Badge>
              </Button>
              <div className="retiro-modal-button-area">
                {props.firma ? (
                  <div className="retiro-modal-button-area-firma">
                    <Button style={{ outline: "none" }} color="link" outline>
                      Firma
                      <Badge color="success" pill>
                        <FaCheck />
                      </Badge>
                    </Button>
                  </div>
                ) : (
                  <FileUploader />
                )}
                <Button
                  color="primary"
                  onClick={props.onClick}
                  disabled={props.buttonLoading}
                >
                  {props.buttonTitle}
                </Button>
              </div>
            </div>
          </ModalFooter>
        ) : null}
      </Modal>
    );
}

export default CustomModalRetiro;